function showResult(container) {
  container.querySelector('.calculateContainer')?.classList.add('hidden');
  container.querySelector('.resultContainer')?.classList.remove('hidden');
  container.classList.add('resultHeightOverride');
}
  const error_text = document.getElementById('error_text').value;
function calculateBustSize() {
  const container = document.getElementById('bra_size_calculator_container');
  const upper = parseFloat(container.querySelector('#upperChest').value);
  const under = parseFloat(container.querySelector('#underBust').value);
  const resultText = container.querySelector('.calculated-result');

  if (isNaN(upper) || isNaN(under)) {
    resultText.textContent = "⚠️ "+error_text;
    showResult(container);
    return;
  }

  const diff = upper - under;

  if (diff < 7.5 || diff > 30) {
    resultText.textContent = "⚠️ "+error_text;
    showResult(container);
    return;
  }

  const band = Math.round(under / 5) * 5;

  const cupSizes = [
    { minDiff: 7.5, cup: "AA" },
    { minDiff: 10, cup: "A" },
    { minDiff: 12.5, cup: "B" },
    { minDiff: 15, cup: "C" },
    { minDiff: 17.5, cup: "D" },
    { minDiff: 20, cup: "E" },
    { minDiff: 22.5, cup: "F" },
    { minDiff: 25, cup: "G" },
    { minDiff: 27.5, cup: "H" },
    { minDiff: 30, cup: "I" },
  ];

  let cup = "⚠️ "+error_text;

  for (let i = 0; i < cupSizes.length; i++) {
    const curr = cupSizes[i];
    const next = cupSizes[i + 1];
    if (!next || (diff >= curr.minDiff && diff < next.minDiff)) {
      cup = curr.cup;
      break;
    }
  }

  resultText.textContent = `${cup}${band}`;
  showResult(container);

  console.log('upper', upper);
  console.log('under', under);
  console.log('cup', cup);
}

function calculatePantySize() {
  const container = document.getElementById('girdle_size_calculator_container');
  const hips = parseFloat(container.querySelector('#pantyHipSize').value);
  const resultText = container.querySelector('.calculated-result');

  if (isNaN(hips)) {
    resultText.textContent = "⚠️ "+error_text;
    showResult(container);
    return;
  }

  const pantySizes = [
    { size: "M", min: 87, max: 95 },
    { size: "L", min: 92, max: 100 },
    { size: "LL", min: 97, max: 105 },
    { size: "3L/EL", min: 102, max: 110 }
  ];

  // Get all matching sizes instead of just the first
  const matches = pantySizes
    .filter(entry => hips >= entry.min && hips <= entry.max)
    .map(entry => entry.size);

  // const size = matches.length > 0 ? matches.join(" or ") : "XXL or above";
  const size = matches.length > 0 ? matches.join(" or ") : "❓ No matching size found.";
  resultText.textContent = `${size}`;
  showResult(container);
}


function calculateUnderwearSize() {
  const container = document.getElementById('panty_size_calculator_container');
  const hips = parseFloat(container.querySelector('#underwearHipSize').value);
  const resultText = container.querySelector('.calculated-result');

  if (isNaN(hips)) {
    resultText.textContent = "⚠️ "+error_text;
    showResult(container);
    return;
  }

  const sizeChart = [
    { size: "M", min: 87, max: 95 },
    { size: "L", min: 92, max: 100 },
    { size: "LL", min: 97, max: 105 },
    { size: "3L/EL", min: 102, max: 110 }
  ];

  // Get all matching sizes for overlapping ranges
  const matches = sizeChart
    .filter(entry => hips >= entry.min && hips <= entry.max)
    .map(entry => entry.size);

  const size = matches.length > 0 ? matches.join(" or ") : "❓ No matching size found.";
  resultText.textContent = `${size}`;
  showResult(container);
}


function resetCalculator(type, mode) {
  const containerIdMap = {
    bust: 'bra_size_calculator_container',
    girdle: 'girdle_size_calculator_container',
    panty: 'panty_size_calculator_container'
  };

  const container = document.getElementById(containerIdMap[mode]);
  if (!container) return;

  container.querySelectorAll('input').forEach(input => input.value = '');
  
  if (type === 'reset' || type === 'refresh') {
    container.querySelector('.calculateContainer')?.classList.remove('hidden');
    container.querySelector('.resultContainer')?.classList.add('hidden');
    container.classList.remove('resultHeightOverride');
  }
}
